import initTeamFilter from './components/team-filter';

const teamFilter = document.querySelector('.js-team-filter');

if (teamFilter) {
    initTeamFilter(teamFilter);
}
